import React, { useState, useEffect } from "react";

interface HotkeyOrMouseInputProps {
    label: string;
    currentKey: string;
    onUpdateKey: (newKey: string) => void;
    allBindings: Set<string>; // Сет для отслеживания всех занятых биндов
}

const HotkeyButton: React.FC<HotkeyOrMouseInputProps> = ({ label, currentKey, onUpdateKey, allBindings }) => {
    const [isListening, setIsListening] = useState(false); // Для отслеживания нажатий
    const [keyPressed, setKeyPressed] = useState<string>(currentKey); // Текущая кнопка (клавиша или мышь)

    // Для клавиатурных событий
    const handleKeydown = (e: KeyboardEvent) => {
        if (isListening) {
            const newKey = e.key.toUpperCase(); // Название клавиши
            if (allBindings.has(newKey)) {
                alert("This key is already bound to another action!");
                setIsListening(false); // Останавливаем прослушивание
                return;
            }
            setKeyPressed(newKey);
            setIsListening(false);
            onUpdateKey(newKey); // Обновляем ключ
        }
    };

    // Для мышиных событий
    const handleMouseClick = (e: MouseEvent) => {
        if (isListening) {
            let newKey = "";
            // Убедимся, что правильно определяем все кнопки
            switch (e.button) {
                case 0:
                    newKey = "LeftMouseButton"; // Левая кнопка мыши
                    break;
                case 1:
                    newKey = "MiddleMouseButton"; // Средняя кнопка мыши
                    break;
                case 2:
                    newKey = "RightMouseButton"; // Правая кнопка мыши
                    break;
                case 3:
                    newKey = "X2MouseButton"; // Боковая кнопка назад
                    break;
                case 4:
                    newKey = "X1MouseButton"; // Боковая кнопка вперед
                    break;
                default:
                    setIsListening(false);// На случай нестандартных кнопок
                    return;
            }
            if (allBindings.has(newKey)) {
                alert("This mouse button is already bound to another action!");
                setIsListening(false); // Останавливаем прослушивание
                return;
            }
            setKeyPressed(newKey);
            setIsListening(false);
            onUpdateKey(newKey); // Обновляем кнопку
        }
    };

    useEffect(() => {
        if (isListening) {
            window.addEventListener("keydown", handleKeydown); // Слушаем клавиатуру
            window.addEventListener("mousedown", handleMouseClick); // Слушаем мышь
        }else {
            window.removeEventListener("keydown", handleKeydown);
            window.removeEventListener("mousedown", handleMouseClick);
        }

        return () => {
            window.removeEventListener("keydown", handleKeydown);
            window.removeEventListener("mousedown", handleMouseClick);
        };
    }, [isListening]);

    const startListening = () => {
        setIsListening(true);
    };

    return (
        <div className="w-full">
            {/* Лейбл */}
            <label className="mb-2 font-semibold">{label}</label>

            {/* Контейнер для ввода */}
            <div
                className="p-4 border-2 border-gray-300 rounded-lg"
                onClick={startListening} // При клике на область начинается прослушивание
                style={{ cursor: "pointer" }}
            >
                {/* Сообщение, когда прослушивание активно или текущее значение кнопки */}
                {isListening ? "Press a key or click a mouse button" : `Current key: ${keyPressed}`}
            </div>

            {/* Подсказка о том, как изменить кнопку */}
            <p className="mt-2 text-sm text-gray-500">
                Click to change, then press a key or mouse button
            </p>
        </div>
    );
};

export default HotkeyButton;
